import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import AboutNaselit from '@/components/aboutNaselit'
import M170 from '@/components/product/M170'
import M220 from '@/components/product/M220'
import MUTAsystem from '@/components/product/MUTAsystem'
import Wc from '@/components/product/wc'
import ApplicationPlan from '@/components/applicationPlan'
import Recruit from '@/components/recruit'
import ContactUs from '@/components/contactUs'
import FivegTest from '@/components/application/5gTest'
import Ota from '@/components/application/ota'
import CNSimulator from '@/components/product/CNSimulator'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main
    },
    {
      path: '/aboutNaselit',
      name: 'aboutNaselit',
      component: AboutNaselit
    },
    {
      path: '/m170',
      name: 'M170',
      component: M170
    },
    { 
      path:'/CNSimulator',
      name:'CNSimulator',
      component: CNSimulator
    },
    {
      path: '/m220',
      name: 'M220',
      component: M220
    },
    {
      path: '/mutaSystem',
      name: 'MUTAsystem',
      component: MUTAsystem
    },
    {
      path: '/wc',
      name: 'Wc',
      component: Wc
    },
    {
      path: '/applicationPlan',
      name: 'ApplicationPlan',
      component: ApplicationPlan
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: Recruit
    },
    {
      path: '/contactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/5gTest',
      name: 'FivegTest',
      component: FivegTest
    },
    {
      path: '/ota',
      name: 'Ota',
      component: Ota
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js